import axios from 'axios';

export const dataAPI = axios.create ({
    baseURL : '/'
});




// WEBPACK FOOTER //
// ./src/APIs/api.js